var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"title":_vm.$t('rss.tooltip'),"target":"_blank","href":_vm.feed}},[_c('img',{staticClass:"service-icon",attrs:{"src":require("@/assets/img/rss.png"),"alt":"RSS icon"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }